import { useEffect, useState } from 'react'
import axiosInstance from '../components/lib/axiosInstance'
import IssueManagementContent from '../components/IssueManagementContent'
import { Issue } from '../components/commons'

const IssueManagement = () => {
  const [data, setData] = useState<Issue[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true)
      try {
        const savedProjectId = localStorage.getItem('selectedProject')
        const response = await axiosInstance.get(`/api/v1/Issues/GetByProject?ProjectId=${savedProjectId}`)
        setData(response?.data?.data)
      } catch (error) {
        console.error('Error fetching issues by project:', error)
      } finally {
        setLoading(false) // Set loading to false after fetching completes
      }
    }

    fetchData()
  }, [])

  return <IssueManagementContent data={data} isLoading={loading} />
}

export default IssueManagement
